import React from "react";

import styled from "styled-components";

const StyledPlayButton = styled.div`
  background-color: ${({ theme }) => theme.primaryColor};
  color: #fff;
  border-radius: 50%;
  width: 84px;
  height: 84px;
  cursor: pointer;
  position: relative;

  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-45%, -50%);
  }
`;

function PlayButton() {
  return (
    <StyledPlayButton>
      <svg
        className="bi bi-play-fill"
        fill="currentColor"
        height="60"
        viewBox="0 0 16 16"
        width="60"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* eslint-disable-next-line max-len */}
        <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z" />
      </svg>
    </StyledPlayButton>
  );
}
export default PlayButton;
